import React, { useCallback } from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { submitEmployeeWithholdings } from 'api';
import { postJSON } from 'api/fetch';
import { partial } from 'lodash';
import PropTypes from 'prop-types';

import Box from 'components/Box';

import { cxHelpers } from 'util/className';
import * as flashNotice from 'util/flashNotice';
import { toI18n } from 'util/i18n';

import { formatEmployeeWithholdingPayload } from './utils';
const { cx, cxEl } = cxHelpers('WithholdingForm');

import * as yup from 'yup';

import EditableSection from '../../EditableSection';

import WithholdingFormFields from './WithholdingFormFields';

const WithholdingForm = ({
  user,
  form,
  formIndex,
  onCancel,
  updateUserInfo,
  onSaveCompleted,
  teamDrawerMode = false,
}) => {
  const handleOnSave = useCallback(
    (form_id, values) =>
      postJSON(submitEmployeeWithholdings(user.get('id')), {
        form_id,
        parameters: formatEmployeeWithholdingPayload(values),
      }).catch(() => {
        flashNotice.error(
          toI18n(
            'team.employee_profile.tax_information.error.submit_withholding_failed'
          )
        );
      }),
    [user]
  );

  function createYupSchema(schema, parameter) {
    const name = parameter.get('name');
    const required = parameter.get('required');
    const depends_on = parameter.get('depends_on');

    if (required) {
      if (depends_on) {
        schema[name] = yup.string().when(depends_on.get('name'), {
          is: depends_on.get('value_matches'),
          then: yup
            .string()
            .required(
              toI18n('team.employee_profile.tax_information.error.required')
            ),
        });
      } else {
        schema[name] = yup
          .string()
          .required(
            toI18n('team.employee_profile.tax_information.error.required')
          );
      }
    }

    return schema;
  }

  const yupSchema = form.get('parameters').reduce(createYupSchema, {});

  const validationSchema = yup.object().shape(yupSchema);

  return (
    <Box className={cx()}>
      <EditableSection
        initEditMode
        className={cxEl(`editable-section`)}
        cxEl={cxEl}
        onCancel={onCancel}
        updateUserInfo={updateUserInfo}
        initialValues={{}}
        onSave={partial(handleOnSave, form.get('id'))}
        onSaveCompleted={onSaveCompleted}
        showCancelButton={!teamDrawerMode}
        noBorder={teamDrawerMode}
        noPadding={teamDrawerMode}
        validationSchema={validationSchema}
      >
        {({ values }) => (
          <WithholdingFormFields
            form={form}
            formIndex={formIndex}
            formValues={values}
          />
        )}
      </EditableSection>
    </Box>
  );
};

WithholdingForm.propTypes = {
  user: ImmutablePropTypes.map.isRequired,
  form: PropTypes.object.isRequired,
  formIndex: PropTypes.number.isRequired,
  onCancel: PropTypes.func.isRequired,
  updateUserInfo: PropTypes.func.isRequired,
  onSaveCompleted: PropTypes.func.isRequired,
  teamDrawerMode: PropTypes.bool,
};

export default WithholdingForm;
